import type { FunctionComponent } from 'react';
import type { TypeOrderTableProps } from './types';

/**
 * OrderTable
 */
export const OrderTable: FunctionComponent<TypeOrderTableProps> = ({
  className,
  headers,
  children,
}: TypeOrderTableProps) => (
  <div className="overflow-x-scroll">
    <table {...(className && { className })}>
      {headers && (
        <thead className="u-actions u-actions--link border border-primary-900 bg-bg-tertiary text-left text-typo-alternative">
          <tr>
            {headers.map((header, index) => (
              <th className="min-w-[120px] p-2 font-normal" key={index}>
                {header}
              </th>
            ))}
          </tr>
        </thead>
      )}

      <tbody>{children}</tbody>
    </table>
  </div>
);
